<template>
  <!-- 模型训练-训练模型配置 -->
  <div class="training-configuration-popup">

    <div class="popup-list">
      <!-- 训练配置 -->
      <gat-popup
        :class="['training-configuration', popupActive === 'training_configuration' ? 'on' : 'off']"
        :title="'训练配置'"
        :primary-button="'关闭'"
        @confirm="confirmConfiguration"
        @cancel="confirmConfiguration"
      >
        <template v-slot:content>
          <div id="report-cnt" class="report-cnt scroll-bar">
            <div class="custom custom-configuration">
              <div class="tr">
                <div class="td"><h4>自定义训练配置</h4>：</div>
                <div class="td">
                  <el-switch v-model="toConfigureData.switchCustom" active-color="#4c88ff" inactive-color="#DCDFE6"></el-switch>
                  <div>
                  <el-select
                    ref="refSelectVersion"
                    class="select-box select-box-training"
                    v-model="toConfigureData.activeVersion"
                    placeholder="请选择版本"
                    filterable
                    size='mini'
                    :disabled="!toConfigureData.switchCustom"
                    @change="activeVersionChange"
                  >
                    <el-option
                      v-for="item in modelVersionList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  </div>
                </div>
              </div>
            </div>

            <div class="custom">
              <div class="tr">
                <div class="td"><h5>数据信息</h5></div>
                <div class="td"></div>
              </div>

              <div class="tr">
                <div class="td"><h6 class="h6-right">自定义验证集</h6>：</div>
                <div class="td">
                  <el-switch
                    :class="{'events-disable': !toConfigureData.switchCustom}"
                    v-model="toConfigureData.switchCustomValidation"
                    active-color="#4c88ff"
                    inactive-color="#DCDFE6">
                  </el-switch>
                </div>
              </div>
              <div class="tr">
                <div class="td"><h6 class="h6-right">选择验证集</h6>：</div>
                <div class="td">
                  <div class="td">
                    <el-button :class="{'events-disable': !toConfigureData.switchCustomValidation}" size="mini" @click="openSetPopup('verification')"><i class="el-icon-circle-plus"></i> 请选择</el-button>
                  </div>
                </div>
              </div>
              <div class="tr">
                <div class="td"></div>
                <div class="td">验证集标签应与训练集标签完全一致，为获取更好的模型效果，验证集数据需更贴近实际应用场景。</div>
              </div>
              <div class="tr">
                <div class="td"></div>
                <div class="td td-table">
                  <el-table :data="toConfigureData.tableValidation" border style="width: 100%" :cell-style="{padding: '0'}" :header-cell-style="{color:'#333', fontWeight: '600'}">
                    <el-table-column align="center" prop="datasetName" label="数据集"></el-table-column>
                    <el-table-column align="center" prop="datasetVersion" label="版本号" width="70"></el-table-column>
                    <el-table-column align="center" prop="datasetNum" label="数据总量" width="80"></el-table-column>
                    <el-table-column align="center" prop="labelIdNum" :label="modelType==1 ? '图片数':'已标注数'" width="80"></el-table-column>
                    <el-table-column align="center" prop="labelNames" label="标签名称"></el-table-column>
                    <el-table-column align="center" label="操作" width="50px">
                      <template slot-scope="scope">
                        <el-button :class="{'events-disable': !toConfigureData.switchCustomValidation}" @click.native.prevent="handleDelete(scope.$index, scope.row, 'validation')" type="text" size="small">移除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="tr">
                <td class="td"></td>
                <div class="td tips-red">
                  <span>提示：上传自定义验证集的标签必须与训练集的标签完全一致（全集）</span>
                </div>
              </div>

              <div class="tr">
                <div class="td"><h6 class="h6-right">自定义测试集</h6>：</div>
                <div class="td">
                  <el-switch :class="{'events-disable': !toConfigureData.switchCustom}" v-model="toConfigureData.switchCustomTest" active-color="#4c88ff" inactive-color="#DCDFE6"> </el-switch>
                </div>
              </div>
              <div class="tr">
                <div class="td"><h6 class="h6-right">选择测试集</h6>：</div>
                <div class="td">
                  <el-button :class="{'events-disable': !toConfigureData.switchCustomTest}" size="mini" @click="openSetPopup('test')"><i class="el-icon-circle-plus"></i> 请选择</el-button>
                </div>
              </div>
              <div class="tr">
                <div class="td"></div>
                <div class="td">AI 模型的效果的测试不能使用训练数据集进行测试，应使用训练数据集外的数据测试，这样才能真实的反应模型效果。</div>
              </div>
              <div class="tr">
                <div class="td"></div>
                <div class="td td-table">
                  <el-table :data="toConfigureData.tableTest" border style="width: 100%" :cell-style="{padding: '0'}" :header-cell-style="{color:'#333', fontWeight: '600'}">
                    <el-table-column align="center" prop="datasetName" label="数据集"></el-table-column>
                    <el-table-column align="center" prop="datasetVersion" label="版本号" width="70"></el-table-column>
                    <el-table-column align="center" prop="datasetNum" label="数据总量" width="80"></el-table-column>
                    <el-table-column align="center" prop="labelIdNum" :label="modelType==1 ? '图片数':'已标注数'" width="80"></el-table-column>
                    <el-table-column align="center" prop="labelNames" label="标签名称"></el-table-column>
                    <el-table-column align="center" label="操作" width="50px">
                      <template slot-scope="scope">
                        <el-button :class="{'events-disable': !toConfigureData.switchCustomTest}" @click.native.prevent="handleDelete(scope.$index, scope.row, 'test')" type="text" size="small">移除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="tr">
                <td class="td"></td>
                <div class="td tips-red">
                  <span>提示：上传自定义测试集的标签必须为训练集的标签的全集或子集</span>
                </div>
              </div>
            </div>

            <div class="custom custom-table">
              <div class="tr">
                <div class="td"><h5>配置信息</h5></div>
                <div class="td"></div>
              </div>
              <el-row>
                <el-col :span="12">
                  <div class="tr">
                    <div class="td"><h6>增量学习</h6></div>
                    <div :class="['td', {'events-disable': !toConfigureData.switchCustom}]">
                      <el-switch v-model="configurationInformation.switchIncrement" active-color="#4c88ff" inactive-color="#DCDFE6"></el-switch>
                      <el-select
                        ref="refSelectInformation"
                        class="select-box select-box-training"
                        v-model="configurationInformation.activeVersionIncrement"
                        placeholder="请选择版本"
                        filterable
                        size='mini'
                        :disabled="!configurationInformation.switchIncrement"
                      >
                        <el-option
                          v-for="item in incrementList"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="tr">
                    <div class="td"><h6>服务器</h6></div>
                    <div :class="['td', {'events-disable': !toConfigureData.switchCustom}]">
                      <el-radio v-model="configurationInformation.radioValue" label="1">CPU</el-radio>
                      <el-radio v-model="configurationInformation.radioValue" label="2" v-if="modelGPU">GPU</el-radio>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="tr">
                    <div class="td"><h6>Epoch</h6></div>
                    <div :class="['td', {'events-disable': !toConfigureData.switchCustom}]">
                      <!-- <el-input 
                        v-model="configurationInformation.batch" 
                        oninput ="value=value.replace(/[^\d]/g,'')" 
                        @blur="configurationInformation.batch=$event.target.value" 
                        placeholder="请输入批次" 
                        size="mini"
                        maxlength="10"
                      ></el-input> -->
                      <el-input-number
                        v-model.trim="configurationInformation.batch"
                        @blur="numberFunction('batch', configurationInformation.batch)"
                        placeholder="请输入Epoch"
                        :min="1"
                        maxlength="10"
                        size="mini"
                        :controls="false"
                        disabled
                      ></el-input-number>
                    </div>
                    <div class="tips-red">
                      <span>Epoch= (Batch Size*Iteration)/N</span>
                    </div>
                  </div>
                </el-col>
                <!-- <el-col :span="12">
                  <div class="tr tips-red">
                    <span>Epoch= (Batch Size*Iteration)/N</span>
                  </div>
                </el-col> -->
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="tr">
                    <div class="td"><h6>Batch Size</h6></div>
                    <div :class="['td', {'events-disable': !toConfigureData.switchCustom}]">
                      <!-- <el-input 
                        v-model="configurationInformation.batchSize" 
                        oninput ="value=value.replace(/[^\d]/g,'')" 
                        @blur="configurationInformation.batchSize=$event.target.value" 
                        placeholder="请输入大小" 
                        size="mini"
                        maxlength="10"
                      ></el-input> -->
                      <el-input-number
                        v-model.trim="configurationInformation.batchSize"
                        @blur="numberFunction('batchSize', configurationInformation.batchSize)"
                        placeholder="请输入Batch Size"
                        :min="defaultValue.sizeMin"
                        :max="defaultValue.sizeMax"
                        maxlength="10"
                        size="mini"
                        :controls="false"
                      ></el-input-number>
                    </div>
                    <div class="tips-red">
                      <span>提示：请输入{{defaultValue.sizeMin}}~{{defaultValue.sizeMax}}之间的数值。</span>
                    </div>
                  </div>
                </el-col>
                <!-- <el-col :span="12">
                  <div class="tr tips-red">
                    <span>提示：请输入{{defaultValue.sizeMin}}~{{defaultValue.sizeMax}}之间的数值。</span>
                  </div>
                </el-col> -->
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="tr">
                    <div class="td"><h6>迭代次数 Iteration</h6></div>
                    <div :class="['td', {'events-disable': !toConfigureData.switchCustom}]">
                      <!-- <el-input 
                        v-model="configurationInformation.iterations" 
                        oninput ="value=value.replace(/[^\d]/g,'')" 
                        @blur="configurationInformation.iterations=$event.target.value" 
                        placeholder="请输入迭代次数" 
                        size="mini"
                        maxlength="10"
                      ></el-input> -->
                      <el-input-number
                        v-model.trim="configurationInformation.iterations"
                        @blur="numberFunction('iterations', configurationInformation.iterations)"
                        placeholder="请输入迭代次数"
                        :min="defaultValue.iterationsMin"
                        :max="defaultValue.iterationsMax"
                        maxlength="10"
                        size="mini"
                        :controls="false"
                      ></el-input-number>
                      <!-- :controls="false"(按钮) :precision="2"（精度） :step="0.1"（增加的步数） -->
                    </div>
                    <div class="td tips-red">
                      <span>提示：请输入{{defaultValue.iterationsMin}}~{{defaultValue.iterationsMax}}之间的数值。迭代次数影响训练时长。</span>
                    </div>
                  </div>
                </el-col>
                <!-- <el-col :span="12">
                  <div class="tr tips-red">
                    <span>提示：请输入{{defaultValue.iterationsMin}}~{{defaultValue.iterationsMax}}之间的数值。迭代次数影响训练时长。</span>
                  </div>
                </el-col> -->
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="tr">
                    <div class="td"><h6>学习率 Learning Rate</h6></div>
                    <div :class="['td', {'events-disable': !toConfigureData.switchCustom}]">
                      <!-- <el-input 
                        v-model="configurationInformation.learningRate" 
                        oninput ="value=value.replace(/[^0-9.]/,'')" 
                        @blur="configurationInformation.learningRate=$event.target.value" 
                        placeholder="请输入学习率" 
                        size="mini"
                        maxlength="10"
                      ></el-input> -->
                      <el-input-number
                        v-model.trim="configurationInformation.learningRate"
                        placeholder="请输入学习率"
                        :min="defaultValue.learningRateMin"
                        :max="defaultValue.learningRateMax"
                        maxlength="10"
                        size="mini"
                        :disabled="false"
                        :controls="false"
                      ></el-input-number>
                    </div>
                    <div class="td tips-red">
                      <span>提示：请输入{{defaultValue.learningRateMin}}~{{defaultValue.learningRateMax}}之间的数值。</span>
                    </div>
                  </div>
                </el-col>
                <!-- <el-col :span="12">
                  <div class="tr tips-red">
                    <span>提示：请输入{{defaultValue.learningRateMin}}~{{defaultValue.learningRateMax}}之间的数值。</span>
                  </div>
                </el-col> -->
              </el-row>

              <!-- <el-row>
                <el-col :span="24">
                  <div class="tr">
                    <div class="td"></div>
                    <div class="td">
                      <span>迭代次数影响训练时长</span>
                    </div>
                  </div>
                </el-col>
              </el-row> -->
            </div>
          </div>
        </template>
      </gat-popup>

      <!-- 选择验证集、测试集 -->
      <gat-popup
        :class="['popup-addTenant', selectPopupActive === 'verification' || selectPopupActive === 'test' ? 'on' : 'off']"
        :title="'选择数据集'"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="addTenantProject"
      >
        <template v-slot:content>
          <div class="popup-addTenant-centent">
            <div class="centent-left">
              <div class="search-tenant popup-border-color">
                <el-input
                  placeholder="请输入数据集名称"
                  v-model.trim="searchAddTenantName"
                  @keyup.enter.native="onSearchAddTenant"
                >
                  <i slot="suffix" class="icon-search-box" @click="onSearchAddTenant">
                    <span class="el-icon-search"></span>
                  </i>
                </el-input>
              </div>
              <div class="tenant-list popup-border-color">
                <el-tree
                  :data="datasetListAll"
                  show-checkbox
                  default-expand-all
                  node-key="id"
                  ref="tree"
                  highlight-current
                  :props="defaultProps"
                  @check-change="handleCheckChange">
                </el-tree>
              </div>
            </div>
          </div>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import PRETRAIN from "@/axios/pretrain/pretrain.js";

import SearchBox from '@/components/common/SearchBox.vue'
import GatPopup from '@/components/common/GatPopup'

export default {
  name: 'TrainingConfigurationPopup',
  components: {SearchBox, GatPopup},
  props: {
    modelType: {
      type: String,
      default: ''
    },
    popupActive: {
      type: String,
      default: ''
    },
    // 模型id
    modelId: {
      type: String,
      default: ''
    },
    // 数据集id
    datasetId: {
      type: String,
      default: ''
    },
    // 选中的标签id集合
    labelIds: {
      type: Array,
      default: []
    },
    // 选中的标签名称集合
    labelNames: {
      type: Array,
      default: []
    },
    // 选中标签集数量
    labelNum: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      modelGPU: window.gtaAiConfig.modelGPU, // 是否有GPU配置
      datasetListAll: [], // 数据集列表
      selectLabelList: [], // 选中列表
      localDatasetListAll : [], // 存储数据集列表
      localSelectList: [], // 存储选中列表
      // selectDatasetList: [], // 选中标签追加为数据集列表
      // selectCheckedIds: [], // 勾选中的id
      searchAddTenantName: '', // 关联数据集弹窗-搜索
      searchDatasetName: '', // 关联数据集弹窗-搜索数据集
      selectPopupActive: "", // 选择弹窗
      modelVersionList: [], // 模型版本列表
      incrementList: [], // 学习增量列表
      // 训练配置参数
      toConfigureData: {
        switchCustom: false, // 是否开启参数配置 true:开启
        activeVersion: '', // 选中版本
        // 数据信息
        switchCustomValidation: false, // 是否开启自定义验证集 true:开启
        tableValidation: [], // 验证集列表
        switchCustomTest: false, // 是否开始自定义测试集 true:开启
        tableTest: [], // 测试集列表
      },
      // 配置信息
      configurationInformation: {
        switchIncrement: false, // 是否开启增量学习
        activeVersionIncrement: '', // 选中增量学习版本
        radioValue: '1', // 服务器 —— 1:CPU  2:CPG
        batch: '0', // 批次
        batchSize: '16', // 大小
        iterations: '200', // 迭代次数
        learningRate: '0.01', // 学习率
      },
      defaultValue: {
        batchMin: 1,
        batchMax: 0,
        sizeMin: 1,
        sizeMax: 32,
        iterationsMin: 1,
        iterationsMax: 2000,
        learningRateMin: 0.00001,
        learningRateMax: 0.01,
      },
      validationSet: [], // 储存选中版本的验证集
      testSet: [], // 储存选中版本的测试集
    }
  },
  watch: {
    popupActive: {
      handler(val) {
        if (val) {
          this.getModelConfigSelect(); // 查询模型版本配置下拉框
          this.getIncrementalLearningSelect(); // 查询增量学习下拉框
        }
      },
      deep: true,
      immediate: true,
    },
    selectPopupActive: {
      handler(val) {
        if (val) {
          // this.getDatasetList();
        }
      },
      deep: true,
      immediate: true,
    },
    // 监听模型id
    modelId: {
      handler(val) {
        this.toConfigureData.switchCustom = false; // 自定义配置开关
      },
      deep: true,
      immediate: true,
    },
    // 监听数据集id
    datasetId: {
      handler(val) {
        this.toConfigureData.switchCustom = false; // 自定义配置开关
      },
      deep: true,
      immediate: true,
    },
    // 监听标签id集
    labelIds: {
      handler(val) {
        this.toConfigureData.switchCustom = false; // 自定义配置开关
      },
      deep: true,
      immediate: true,
    },
    // 监听是否开启自定义训练配置
    'toConfigureData.switchCustom': {
      handler(val) {
        if (val) {
        } else { // 关闭自定义训练配置
          this.resetConfiguration(); // 重置配置为默认值
          this.$emit('confirmConfiguration'); // 清空已配置的数据
        }
      },
      deep: true,
      immediate: true,
    },
    // 监听是否开启验证集
    'toConfigureData.switchCustomValidation': {
      handler(val) {
        if (val) {
          this.toConfigureData.tableValidation = this.validationSet; // 验证集列表
        } else {
          this.toConfigureData.tableValidation = []; // 验证集列表
        }
      },
      deep: true,
      immediate: true,
    },
    // 监听是否开启测试集
    'toConfigureData.switchCustomTest': {
      handler(val) {
        if (val) {
          this.toConfigureData.tableTest = this.testSet; // 测试集列表
        } else {
          this.toConfigureData.tableTest = []; // 测试集列表
        }
      },
      deep: true,
      immediate: true,
    },
    labelNum: {
      handler(val) {
        if (val) {
          this.batchFunction(this.configurationInformation);
        }
      },
      deep: true,
      immediate: true,
    },
    configurationInformation: {
      handler(val) {
        this.batchFunction(val);
      },
      deep: true,
      immediate: true,
    },
    // 'configurationInformation.iterations': {
    //   handler(val) {
    //     if (val) {
    //       let iterations = JSON.parse(JSON.stringify(val))
    //       iterations = iterations.toString();
    //       this.configurationInformation.iterations = iterations.replace(/[^\d]/g,'');
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  created() {},
  mounted() {
    let that = this
    // 监听滚动条滑动-关闭下拉框
    document.getElementById('report-cnt').onscroll = function() {
      that.$refs.refSelectVersion.blur();
      that.$refs.refSelectInformation.blur();
    };
  },
  methods: {
    // 重置配置为默认值
    resetConfiguration() {
      let that = this;
      this.toConfigureData.activeVersion = ''; // 选中版本
      // 数据信息
      this.toConfigureData.switchCustomValidation = false; // 是否开启自定义验证集 true:开启
      this.toConfigureData.switchCustomTest = false; // 是否开始自定义测试集 true:开启
      this.toConfigureData.tableValidation = []; // 验证集列表
      this.toConfigureData.tableTest = []; // 测试集列表

      function defaultFunction(params) {
        // 配置信息
        that.configurationInformation = {
          switchIncrement: false, // 是否开启增量学习
          activeVersionIncrement: '', // 选中增量学习版本
          radioValue: '1', // 服务器 —— 1:CPU  2:CPG
          batch: '0', // 批次
          batchSize: params.batchSize || '16', // 大小
          iterations: params.iterations || '200', // 迭代次数
          learningRate: params.learningRate || '0.01', // 学习率
        };
      }
      if (this.modelType == 1) {
        defaultFunction(window.gtaAiConfig.imageClassification);
      }
      if (this.modelType == 2) {
        defaultFunction(window.gtaAiConfig.objectDetection);
      }

      this.validationSet = []; // 储存选中版本的验证集
      this.testSet = []; // 储存选中版本的测试集
    },
    // 计算批次结果
    batchFunction(val) {
      if (val) {
        let labelNum = this.labelNum || 1;
        this.configurationInformation.batch = Math.floor(val.batchSize * val.iterations / labelNum);// 计算批次公式
      }
    },
    numberFunction(type, val) {
      if (val) {
        if (type === 'batch') {
          this.configurationInformation.batch = val.toString().split('.')[0];
        }
        if (type === 'batchSize') {
          this.configurationInformation.batchSize = val.toString().split('.')[0];
        }
        if (type === 'iterations') {
          this.configurationInformation.iterations = val.toString().split('.')[0];
        }
      }
    },
    // 关联数据集搜索
    onSearchAddTenant() {
      this.localSelectList = this.selectLabelList; // 存储选中列表

      if (this.searchDatasetName !== this.searchAddTenantName) {
        this.searchDatasetName = this.searchAddTenantName;

        // 查询验证集列表
        if (this.selectPopupActive === 'verification') {
          this.getValidationSetList();
        }
        // 查询测试集列表
        if (this.selectPopupActive === 'test') {
          this.getTestSetList();
        }
      }
    },

    // 根据模型版本查看配置信息
    activeVersionChange(val) {
      let data = {
        id: val
      }
      PRETRAIN.getConfigByModelVersion(data).then((res) => {
        if (res.returnCode == 200 && res.data) {
          this.toConfigureData.switchCustomValidation = res.data.validationSet ? true : false; 
          this.toConfigureData.switchCustomTest = res.data.testSet ? true : false;
          this.validationSet = res.data.validationSet ? JSON.parse(res.data.validationSet) : []; // 存储验证集
          this.testSet = res.data.testSet ? JSON.parse(res.data.testSet) : []; // 存储测试集
          this.toConfigureData.tableValidation = this.validationSet; // 默认验证集
          this.toConfigureData.tableTest = this.testSet; // 默认测试集

          this.configurationInformation = {
            switchIncrement: res.data.incrementalLearning ? true : false, // 是否开启增量学习
            activeVersionIncrement: res.data.incrementalLearning || '', // 选中增量学习版本
            radioValue: res.data.server.toString() || '1', // 1:CPU  2:CPG
            batch: '0', // 批次
            batchSize: res.data.batchSize || '', // 大小 
            iterations: res.data.iteration || '', // 迭代次数
            learningRate: res.data.learningRate || '', // 学习率
          }
        } else {
          this.resetConfiguration(); // 重置配置为默认值
          this.$emit('confirmConfiguration'); // 清空已配置的数据
        }
      })
    },
    // 查询模型版本配置下拉框
    getModelConfigSelect() {
      let data = {
        modelId: this.modelId, // 模型id
        datasetId: this.datasetId, // 数据集id
        labelIds: this.labelIds.join(","), // 标签ids
      }
      PRETRAIN.getModelConfigSelect(data).then((res) => {
        if (res.returnCode == 200 && res.data) {
          this.modelVersionList = res.data;
        } else {
          this.modelVersionList = [];
        }
      })
    },
    // 查询增量学习下拉框
    getIncrementalLearningSelect() {
      let data = {
        modelId: this.modelId, // 模型id
        datasetId: this.datasetId, // 数据集id
        labelIds: this.labelIds.join(","), // 标签ids
      }
      PRETRAIN.getIncrementalLearningSelect(data).then((res) => {
        if (res.returnCode == 200 && res.data) {
          this.incrementList = res.data;
        } else {
          this.incrementList = [];
        }
      })
    },

    // 获取选中数据集-处理为标签列表
    selectLabelListFunc(list) {
      this.selectLabelList = []
      list.forEach(item => {
        item.labelIdList.forEach((i, index) => {
          this.selectLabelList.push({
            id: i, 
            name: item.labelNameList[index], 
            labelId: i, 
            labelName: item.labelNameList[index], 
          })
        });
      });
    },

    // 验证/测试集弹窗 'verification'/'test'
    openSetPopup(val) {
      this.searchDatasetName = '';
      this.searchAddTenantName = '';
      this.selectPopupActive = val;
      // 查询验证集列表
      if (this.selectPopupActive === 'verification') {
        this.getValidationSetList(); // 查询测试集列表
        this.selectLabelListFunc(this.toConfigureData.tableValidation); // 获取选中数据集-处理为标签列表
      }
      // 查询测试集列表
      if (this.selectPopupActive === 'test') {
        this.getTestSetList(); // 查询测试集列表
        this.selectLabelListFunc(this.toConfigureData.tableTest); // 获取选中数据集-处理为标签列表
      }
    },
    // 查询验证集列表
    getValidationSetList() {
      let labelNames = JSON.parse(JSON.stringify(this.labelNames));
      let data = {
        datasetName: this.searchDatasetName, // 搜索数据集名称
        labelNames: labelNames.join(","), // 标签名称集
        type: this.modelType, // 类型：1为图像分类;2为物体检测;3为文本分类;4为文本标注;5为音频分类；6为音频标注
      }
      PRETRAIN.getValidationSetList(data).then((res) => {
        if (res.returnCode == 200 && res.data) {
          this.getDatasetList(res.data); // 获取数据集列表
        } else {
          this.datasetListAll = [];
        }
      })
    },
    // 查询测试集列表
    getTestSetList() {
      let labelNames = JSON.parse(JSON.stringify(this.labelNames));
      let data = {
        datasetName: this.searchDatasetName, // 搜索数据集名称
        labelNames: labelNames.join(","), // 标签名称集
        type: this.modelType, // 类型：1为图像分类;2为物体检测;3为文本分类;4为文本标注;5为音频分类；6为音频标注
      }
      PRETRAIN.getTestSetList(data).then((res) => {
        if (res.returnCode == 200 && res.data) {
          this.getDatasetList(res.data); // 获取数据集列表
        } else {
          this.datasetListAll = [];
        }
      })
    },
    // 获取数据集列表
    getDatasetList(valList) {
      let that = this;
      // 处理树形结构
      let datasetList =  valList || []
      datasetList.forEach(item => {
        item.name = item.datasetName;
        item.id = item.datasetName;
        if (item.children && item.children.length) {
          item.children.forEach(i => {
            usersListFunc(i);
          });
        }
      });
      function usersListFunc(val) {
        val.name = val.datasetVersion || val.labelName;
        val.id = val.datasetId || val.labelId;
        // 验证集
        if (that.selectPopupActive === 'verification' && val.labelId) {
          that.labelIsNotOptional(); // 处理验证集树形结构标签不可选
        } else { // 测试级清除不可选
          let iList = document.getElementsByClassName('el-tree-node');
          iList = Array.from(iList);
          iList.forEach(j => {
            j.classList.remove('events-disable');
          });
        }
        if (val.children && val.children.length) {
          val.children.forEach(i => {
            usersListFunc(i);
          });
        }
      }

      // console.log('datasetList', datasetList);
      this.datasetListAll = datasetList; // 数据集树形列表
      if (!this.searchDatasetName) {
        this.localDatasetListAll = datasetList;
      }

      // 处理返回树形结构选中状态
      this.$nextTick(()=>{
        let selectChIds = [];
        this.selectLabelList = this.localSelectList.length ? this.localSelectList : this.selectLabelList; // 由于执行机制问题，优先取存储选中列表
        if(this.selectLabelList && this.selectLabelList.length){
          this.selectLabelList.forEach(item => {
            selectChIds.push(item.id);
          });
          // this.selectCheckedIds = this.valUnique(selectChIds);
          this.$refs.tree && this.$refs.tree.setCheckedKeys(selectChIds, true, true); // 调用勾选方法
        }
      })
    },

    // 处理验证集树形结构标签不可选
    labelIsNotOptional() {
      this.$nextTick(()=>{
        setTimeout(() => {
          let checkbox = document.getElementsByClassName('el-tree-node__children');
          checkbox = Array.from(checkbox);
          checkbox.forEach(item => {
            if (item.getAttribute('role') === "group") {
              let childList = Array.from(item.childNodes);
              childList.forEach(i => {
                if (i.getAttribute('role') === "treeitem") {
                  let iList = i.getElementsByClassName('el-tree-node');
                  iList = Array.from(iList);
                  iList.forEach(j => {
                    j.classList.add('events-disable');
                  });
                }
              });
            }
          });
        }, 10);
      });
    },

    // 选中用户触发
    handleCheckChange(data, checked, indeterminate) {
      // console.log(data, checked);
        
      if (this.selectPopupActive === 'verification') {
        this.labelIsNotOptional(); // 处理验证集树形结构标签不可选
      }

      let workDeptIds = JSON.parse(JSON.stringify(this.selectLabelList));

      //右边渲染列表
      // if (this.searchDatasetName) { // 搜索状态下
        if (checked) { // 勾选
          workDeptIds.push(data)
          workDeptIds = workDeptIds.filter(item => { // 过滤返回标签
            return item.labelId
          });
        } 
        else { // 取消勾选
          workDeptIds = workDeptIds.filter(item => {
            return item.id !== data.id
          });
        }
      // } 
      // else { // 未搜索查所有
      //   workDeptIds = this.$refs.tree && this.$refs.tree.getCheckedNodes()
      //     .filter(item => { // 过滤返回标签
      //       return item.labelId
      //     });
      // }
      this.selectLabelList = this.unique(workDeptIds);
      // console.log('勾选', this.selectLabelList)

      this.$forceUpdate();
    },
    //去重
    unique(arr) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (arr[i].id == arr[j].id) {
            //第一个等同于第二个，splice方法删除第二个
            arr.splice(j, 1);
            j--;
          }
        }
      }
      return arr
    },
    valUnique(arr) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (arr[i] == arr[j]) {
            //第一个等同于第二个，splice方法删除第二个
            arr.splice(j, 1);
            j--;
          }
        }
      }
      return arr
    },

    // 确认添加数据集标签
    addTenantProject() {
      // 选中标签处理为数据集列表结构
      let datasetList = [];
      let datasetListAll = this.localDatasetListAll;
      datasetListAll.forEach(item => {
        if (item.children && item.children.length) {
          item.children.forEach(i => {
            if (i.children && i.children.length) {
              i.children.forEach(j => {
                let flag = this.selectLabelList.some( (value) => value.id === j.id);
                if (flag) {
                  let params = {
                    id: i.datasetId,
                    datasetName: item.datasetName,
                    datasetId: i.datasetId,
                    datasetVersion: i.datasetVersion,
                    datasetNum: i.datasetNum,
                    labelIdList: [j.labelId],
                    labelNameList: [j.labelName],
                    labelIdNum: Number(j.dataNum)
                  }

                  if (datasetList && datasetList.length) {
                    datasetList.forEach(k => {
                      if (k.datasetId === params.datasetId) {
                        let kFlag = k.labelIdList.every( (value) => value !== j.id);
                        if (kFlag) {
                          k.labelIdList = k.labelIdList.concat(params.labelIdList);
                          k.labelNameList = k.labelNameList.concat(params.labelNameList);
                          k.labelIdNum += params.labelIdNum;
                        }
                      } else {
                        datasetList.push(params);
                      }
                    });
                  } else {
                    datasetList.push(params);
                  }
                }
              });
            }
          });
        }
      });
      datasetList = this.unique(datasetList);
      // this.selectDatasetList = datasetList;

      let labelNumAll = 0;
      datasetList.forEach(item => {
      // this.selectDatasetList.forEach(item => {
        labelNumAll += Number(item.labelIdNum);
        item.labelIds = item.labelIdList.join(",");
        item.labelNames = item.labelNameList.join(",");
      });
      if (labelNumAll > 3000) {
        return this.$message.error(`${this.modelType==1 ? '图片数':'已标注数'}总量超过3000，不允许添加，请重新选择！`)
      }

      if (this.selectPopupActive === 'verification') {
        // this.toConfigureData.tableValidation = this.selectDatasetList;
        this.toConfigureData.tableValidation = datasetList;
      }
      if (this.selectPopupActive === 'test') {
        // this.toConfigureData.tableTest = this.selectDatasetList;
        this.toConfigureData.tableTest = datasetList;
      }
      this.cancelPopup();
    },
    
    // 取消弹窗
    cancelPopup() {
      this.selectPopupActive = '';
      this.datasetListAll = [];
      // this.selectDatasetList = [];
      // this.selectCheckedIds = [];
      this.localSelectList = [];
      this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
    },
    
    // 移除信息
    handleDelete(index, row, type) {
      if (type === 'validation') {
        this.toConfigureData.tableValidation.splice(index, 1);
      }
      if (type === 'test') {
        this.toConfigureData.tableTest.splice(index, 1);
      }
    },
    // 确认自定义训练配置
    confirmConfiguration() {
      let configureData = this.toConfigureData;
      let params = this.configurationInformation;

      if (!params.batchSize) {
        return this.$message.error('请输入Batch Size');
      }
      if (!params.iterations) {
        return this.$message.error('请输入迭代次数');
      }
      if (!params.learningRate) {
        return this.$message.error('请输入学习率');
      }

      let validationSet = configureData.switchCustomValidation && configureData.tableValidation.length ? JSON.stringify(configureData.tableValidation) : '';
      let testSet = configureData.switchCustomTest && configureData.tableTest.length ? JSON.stringify(configureData.tableTest) : '';
      let incrementalLearning = params.switchIncrement ? params.activeVersionIncrement : ''; // 判断是否开启增量学习配置

      let data = {
        validationSet: validationSet, // 验证集
        testSet: testSet, // 测试集
        incrementalLearning: incrementalLearning, // 增量学习
        server: Number(params.radioValue), // 服务器：1代表CPU；2代表GPU
        epoch: params.batch == 0 ? 1 : params.batch, // 纪元（由公式计算出来）
        batchSize: params.batchSize, // 批量大小
        iteration: params.iterations, // 迭代次数
        learningRate: params.learningRate, // 学习率
      }
      if (this.toConfigureData.switchCustom) {
        this.$emit('confirmConfiguration', data);
      } else {
        this.$emit('confirmConfiguration', {});
      }
    },
    celPopup() {
      this.$emit('cancelPopup');
    }
  },
}
</script>

<style lang="scss" scoped>
.training-configuration-popup {
  width: 100%;
  height: 100%;

  .popup-list {
    .training-configuration,
    .popup-addTenant {
      &.off {
        display: none;
      }
    }
    .popup {
      z-index: 3;
    }
    .training-configuration{
      &::v-deep .popup-inner {
        width: 800px;
        height: 600px;
        min-height: 540px;
        .popup-buttons {
          bottom: 25px;
          .el-button:last-child {
            display: none;
          }
        }
  
        .report-cnt {
          height: 500px;
          overflow-x: hidden;
          overflow-y: auto;
          .custom {
            margin: 20px 0;
            .tr {
              display: flex;
              align-items: center;
              font-size: 14px;
              // line-height: 20px;
              margin: 10px 0;
              h4 {
                color: #4C88FF;
                font-size: 16px;
              }
              h5 {
                color: #4C88FF;
                font-size: 14px;
                border-left: 3px solid #4C88FF;
                padding-left: 5px;
                line-height: 14px;
              }
              .td {
                display: flex;
                // align-items: center;
                word-break: break-all;
                word-wrap: break-word;
                white-space: pre-wrap;
                &:first-child {
                  color: #000;
                  width: 130px;
                  justify-content: space-between;
                  align-items: center;
                  .h6-right {
                    flex: 1;
                    text-align: right;
                    margin-right: 5px;
                  }
                }
                &:last-child {
                  flex: 1;
                  align-items: center;
                  .el-switch {
                    margin-right: 10px;
                  }
                  .el-button--mini {
                    padding: 5px 7px 5px 5px;
                  }
                }
              }
            }
            .el-row {
              display: flex;
              align-items: center;
              border-top: 1px solid #EBEEF5;
              border-left: 1px solid #EBEEF5;
              border-right: 1px solid #EBEEF5;
              &:last-child {
                border-bottom: 1px solid #EBEEF5;
              }
              &:nth-child(n+2) {
                .el-col:last-child {
                  border-right: none;
                }
              }
              .el-col {
                height: 48px;
                display: flex;
                &:first-child {
                  border-right: 1px solid #EBEEF5;
                }
                .tr {
                  .td {
                    box-sizing: border-box;
                  }
                  .td:first-child {
                    height: 48px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-right: 1px solid #EBEEF5;
                    // padding-left: 5px;
                  }
                  .td:nth-child(n+2) {
                    padding-left: 10px;
                  }
                }
              }
            }
            .tips-red {
              color: #999;
              padding-left: 10px;
            }
  
            // &.custom-configuration {
            //   .tr:first-child {
            //     .td:first-child {
            //       line-height: 28px;
            //     }
            //   }
            // }
          } 
        }
        
        .select-box-training {
          width: 120px;
          max-width: 120px;
        }
      }
    }
    .popup-addTenant {
      z-index: 9;
      &::v-deep .popup-inner {
        width: 500px;
        height: 500px;
        .popup-buttons {
          position: static;
          text-align: right;
          margin-right: 120px;
        }
      }
      &::v-deep .popup-head {
        color: #2B6CEB;
        font-weight: 700;
      }
      .popup-addTenant-centent {
        padding: 32px 20px;
        display: flex;
        justify-content: space-between;
        .popup-border-color {
          border: 1px solid #85B6FF;
          box-shadow: 0px 2px 8px 0px rgba(59, 135, 249, 0.1);
        }
        .centent-left {
          width: 400px;
          .search-tenant {
            height: 36px;
            margin-bottom: 2px;
            box-sizing: border-box;
            overflow: hidden;
            /deep/.el-input {
              margin-top: 0;
              height: 36px;
            }
            /deep/.el-input__inner {
              width: 100%;
              height: 100%;
              border: none;
            }
            .icon-search-box {
              font-size: 20px;
              // vertical-align: -15px;
              line-height: 36px;
              padding-right: 5px;
              cursor: pointer;
            }
          }
        }

        .tenant-list {
          height: 276px;
          padding: 10px 0px;
          overflow-x: hidden;
          overflow-y: auto;
          // ul {
          //   li {
          //     // height: 30px;
          //     font-size: 16px;
          //     display: flex;
          //     align-items: center;
          //     padding: 5px 20px;
          //     i {
          //       width: 18px;
          //       height: 18px;
          //       box-sizing: border-box;
          //       cursor: pointer;
          //     }
          //     .icon-circular {
          //       border: 1px solid #BBBFD0;
          //       border-radius: 50%;
          //     }
          //     .el-icon-success {
          //       color: #3B87F9;
          //       font-size: 20px;
          //     }
          //     .el-icon-success:before {
          //       margin-left: -1px;
          //     }
          //     span {
          //       flex: 1;
          //     }
          //     .span-tenantName {
          //       margin-left: 10px;
          //     }
          //     &:hover {
          //       background: #EEF4FC;
          //     }
          //   }
          //   .tenant-list-li {
          //     display: flex;
          //     justify-content: space-between;
          //     align-items: center;
          //     .el-icon-close {
          //       color: #3B87F9;
          //       font-size: 20px;
          //       font-weight: 700;
          //     }
          //   }
          // }
          /*修改滚动条样式*/
          &::-webkit-scrollbar{
            width: 6px;
            height: 10px;
          }
          &::-webkit-scrollbar-track{
            // background: rgb(239, 239, 239);
            background: #EEF4FC;
            border-radius: 2px;
          }
          &::-webkit-scrollbar-thumb{
            background: #3B87F9;
            border-radius:10px;
          }
          &::-webkit-scrollbar-thumb:hover{
            background: #3B87F9;
          }
          &::-webkit-scrollbar-corner{
            background: #179a16;
          }
        }
      }
    }
    .pop-select {
      width: 100%;
    }
    .pop-el-form {
      margin-top: 30px;
    }
  }
}
</style>